module.exports = __webpack_public_path__ + "img/400.8ba8621e.svg";